import { FlexColumn } from "src/components/ui/common";
import device from "src/constants/media";
import { colors } from "src/theme/colors";
import styled from "styled-components";

export const ContentWrapper = styled(FlexColumn)`
  position: relative;
  margin-bottom: 80px;
  @media ${device.tablet} {
    flex-direction: row;
  }
  @media ${device.laptopL} {
    width: 1096px;
    margin: 0 auto;
    margin-bottom: 80px;
    justify-content: center;
  }
`;

export const BackButtonWrapper = styled.div`
  width: fit-content;
  padding: 4px 24px 40px;

  @media ${device.tablet} {
    padding: 40px 0 0 24px;
  }
  @media ${device.laptop} {
    padding: 40px 0 0 172px;
  }
  @media ${device.laptopS} {
    padding: 40px 0 0 80px;
  }
  @media ${device.laptopL} {
    position: absolute;
    left: 0;
  }

  :hover {
    div {
      background-color: ${colors.mainVeryLight};
    }
  }
`;

export const BackButtonImageWrapper = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${colors.greyVeryLight};
  border-radius: 50%;
  cursor: pointer;
`;

export const SectionsWrapper = styled(FlexColumn)`
  padding: 0 24px;
  max-width: 800px;
  gap: 24px;

  @media ${device.tablet} {
    padding: 40px 0 0 48px;
    gap: 48px;
  }
`;
